/* eslint-disable @typescript-eslint/no-explicit-any */
import { IEvent } from '@interfaces/IEvent';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { Action } from '@ngrx/store';

export enum EEventsChangesActions {
  CreateEventRequest = '[Events-changes] Create Event Request',
  CreateEventSuccess = '[Events-changes] Create Event Success',
  CreateEventFailure = '[Events-changes] Create Event Failure',
  ClearCreateEventErrors = '[Events-changes] Clear Create Event Errors',

  EditEventRequest = '[Events-changes] Edit Event Request',
  EditEventSuccess = '[Events-changes] Edit Event Success',
  EditEventFailure = '[Events-changes] Edit Event Failure',
  ClearEditEventErrors = '[Events] Clear Edit Event Errors',

  SetMaterialLoadingShow = '[Events-changes] Set Material Loading Show',
  SetLinkLoadingShow = '[Events-changes] Set Link Loading Show',

  DeleteEventRequest = '[Events-changes] Delete Event Request',
  DeleteEventSuccess = '[Events-changes] Delete Event Success',
  DeleteEventFailure = '[Events-changes] Delete Event Failure',

  AddEventFileRequest = '[Events-changes] Add Event File Request',
  AddEventFileSuccess = '[Events-changes] Add Event File Success',
  AddEventFileFailure = '[Events-changes] Add Event File Failure',
}

export class CreateEventRequest implements Action {
  public readonly type = EEventsChangesActions.CreateEventRequest;

  constructor(public event: IEvent, public period?: number) {}
}

export class CreateEventSuccess implements Action {
  public readonly type = EEventsChangesActions.CreateEventSuccess;
}

export class CreateEventFailure implements Action {
  public readonly type = EEventsChangesActions.CreateEventFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearCreateEventErrors implements Action {
  public readonly type = EEventsChangesActions.ClearCreateEventErrors;
}

export class DeleteEventRequest implements Action {
  public readonly type = EEventsChangesActions.DeleteEventRequest;

  constructor(public event: IEvent) {}
}

export class DeleteEventSuccess implements Action {
  public readonly type = EEventsChangesActions.DeleteEventSuccess;
}

export class DeleteEventFailure implements Action {
  public readonly type = EEventsChangesActions.DeleteEventFailure;

  constructor(public errors: IFormErrors) {}
}

export class EditEventRequest implements Action {
  public readonly type = EEventsChangesActions.EditEventRequest;
  //TODO Альбина должна переделать и убрать any. Чтобы когда убрать eslint-disable линтер не ругался
  constructor(public id: number, public payload: any) {}
}

export class EditEventSuccess implements Action {
  public readonly type = EEventsChangesActions.EditEventSuccess;
}

export class EditEventFailure implements Action {
  public readonly type = EEventsChangesActions.EditEventFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearEditEventErrors implements Action {
  public readonly type = EEventsChangesActions.ClearEditEventErrors;
}

export class AddEventFileRequest implements Action {
  public readonly type = EEventsChangesActions.AddEventFileRequest;

  constructor(public data: FormData, public eventId: number) {}
}

export class AddEventFileSuccess implements Action {
  public readonly type = EEventsChangesActions.AddEventFileSuccess;
}

export class AddEventFileFailure implements Action {
  public readonly type = EEventsChangesActions.AddEventFileFailure;

  constructor(public errors: IFormErrors) {}
}

export class SetMaterialLoadingShow implements Action {
  public readonly type = EEventsChangesActions.SetMaterialLoadingShow;

  constructor(public loading: boolean) {}
}

export class SetLinkLoadingShow implements Action {
  public readonly type = EEventsChangesActions.SetLinkLoadingShow;

  constructor(public loading: boolean) {}
}

export type EventsChangesActions =
  | CreateEventRequest
  | CreateEventSuccess
  | CreateEventFailure
  | ClearCreateEventErrors
  | DeleteEventRequest
  | DeleteEventSuccess
  | DeleteEventFailure
  | EditEventRequest
  | EditEventSuccess
  | EditEventFailure
  | ClearEditEventErrors
  | AddEventFileRequest
  | AddEventFileSuccess
  | AddEventFileFailure
  | SetMaterialLoadingShow
  | SetLinkLoadingShow;
